/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Directive} from '@angular/core';
export class WizardCustomTags {
    // No behavior
    // The only purpose is to "declare" the tag in Angular
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "clr-wizard-title, clr-wizard-pagetitle"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function WizardCustomTags_tsickle_Closure_declarations() {
/** @type {?} */
WizardCustomTags.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WizardCustomTags.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
